import { useState } from "react";
import { Grid } from "@mui/material";
import RequestForm from "./request-form";
import { useTranslation } from "react-i18next";
import { useAutoAnimate } from "@formkit/auto-animate/react";

//general components
import { BaseButton } from "../../../../components/common/base-button/base-button";

//import view components
import ProblemType from "./problem-type";
import ProblemSubType from "./problem-sub-type";

//import styles
import "./user-request.scss";

//import images and icons
import support from "../../../../assets/imgs/support.png";

function UserRequest({ requestList, getRequestList, setIsList }) {
    //genetal
    const { t } = useTranslation();
    const [parent, enableAnimations] = useAutoAnimate(false);
    const width = window.innerWidth;
    const breakpoint = 900;

    const [requestForm, setRequestForm] = useState({ isMain: true, isType: false, isSubType: false, isForm: false });
    const [typeId, setTypeId] = useState("");
    const [selectedSubType, setSelectedSubType] = useState("");
    const handleRequestFormChange = (name, typeId, subTypeValue) => {
        enableAnimations(true);
        setRequestForm({ [name]: true });
        setTypeId(typeId);
        setSelectedSubType(subTypeValue);

        if (width < breakpoint && name !== "isMain") setIsList(false);
        else setIsList(true);
    };

    return (
        <Grid className="user-request" container item xs={12} rowGap={1} justifyContent="center" alignItems="center" ref={parent}>
            {!requestForm.isForm && width > breakpoint ? (
                <Grid container item xs={4.5} md={5} xl={6} justifyContent="center">
                    <img className="user-request__img" src={support} alt="" />
                </Grid>
            ) : null}

            {requestForm.isMain && (
                <Grid className="user-request__container" container item xs={12} md={6} alignItems="center" order={{ xs: 1, md: 2 }}>
                    {width < breakpoint ? (
                        <Grid container item xs={5} justifyContent="flex-end" order={{ xs: 2, md: 1 }}>
                            <img className="user-request__img" src={support} alt="" />
                        </Grid>
                    ) : null}

                    <Grid container item xs={7} md={12} rowGap={1} justifyContent="center">
                        {requestList.all_requests > 0 ? (
                            <span className="user-request__request-status">
                                {t("numberOfSubmittedRequests")}: {requestList.all_requests}
                            </span>
                        ) : (
                            <span className="user-request__request-status">{t("noRequestSubmitted")}</span>
                        )}

                        <Grid container item xs={8} md={10}>
                            <BaseButton
                                text={t("submitRequest")}
                                color="primary"
                                size="large"
                                radius="radius-10"
                                handleClick={() => handleRequestFormChange("isType")}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            )}

            {requestForm.isType && <ProblemType requestList={requestList} handleClick={handleRequestFormChange} />}

            {requestForm.isSubType && (
                <ProblemSubType requestList={requestList} handleClick={handleRequestFormChange} typeId={typeId} defaulValue={selectedSubType} />
            )}

            {requestForm.isForm && (
                <RequestForm
                    getRequestList={getRequestList}
                    handleClick={handleRequestFormChange}
                    typeId={typeId}
                    selectedSubType={selectedSubType}
                />
            )}
        </Grid>
    );
}

export default UserRequest;
